import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';

import { HttpError } from '@bonusly/http';
import { useHttpClient } from '@bonusly/http-client';

type CustomPropertyInputOptionsResponse = Record<string, string[]>;

const QueryKey = {
	ManagerInputOptions: 'manager-input-options',
	UserInputOptions: 'user-input-options',
};

export const useManagerInputOptions = (startDate: Date, endDate: Date) => {
	const http = useHttpClient('v2');
	return useQuery<CustomPropertyInputOptionsResponse, HttpError>(
		[
			QueryKey.ManagerInputOptions,
			{
				startDate,
				endDate,
			},
		],
		async () => {
			const response = await http.get<CustomPropertyInputOptionsResponse>('/analytics/custom_property_input_options/managers', {
				params: {
					start_time: format(startDate, 'yyyy-MM-dd'),
					end_time: format(endDate, 'yyyy-MM-dd'),
				},
			});

			return response.data;
		},
		{
			retry: 2,
			refetchOnWindowFocus: false,
			staleTime: 5 * 60 * 1000,
		}
	);
};

export const useUserInputOptions = (startDate: Date, endDate: Date) => {
	const http = useHttpClient('v2');
	return useQuery<CustomPropertyInputOptionsResponse, HttpError>(
		[
			QueryKey.UserInputOptions,
			{
				startDate,
				endDate,
			},
		],
		async () => {
			const response = await http.get<CustomPropertyInputOptionsResponse>('/analytics/custom_property_input_options/users', {
				params: {
					start_time: format(startDate, 'yyyy-MM-dd'),
					end_time: format(endDate, 'yyyy-MM-dd'),
				},
			});

			return response.data;
		},
		{
			retry: 2,
			refetchOnWindowFocus: false,
			staleTime: 5 * 60 * 1000,
		}
	);
};
